import type { ReactNode } from 'react';
import type { Space } from '../../../../styles/tokens';
import type { ResponsiveValue } from '../../../../util/responsive';
import { VerticalStack, type VerticalStackProps } from '../../../alignment/vertical-stack';
import type { LinkElementType } from '../../../link/base-link';
import { DEFAULT_HEADING_LEVEL_3_TYPOGRAPHY, type TypographyProps } from '../../../typography';
import type { ReadonlyListItem } from '../item/readonly-list-item';
import { ReadonlyList } from '../readonly-list';

export interface ReadonlyListGroup {
  id: string;
  items: ReadonlyListItem[];
  titleGap?: ResponsiveValue<Space>;
  title?: ReactNode;
  titleTypography?: TypographyProps;
}

export interface ReadonlyListStackProps extends VerticalStackProps {
  defaultLinkElement?: LinkElementType;
  groups: ReadonlyListGroup[];
  isPending?: boolean;
  titleGap?: ResponsiveValue<Space>;
  titleTypography?: TypographyProps;
}

export function ReadonlyListStack({
  defaultLinkElement = 'a',
  gap = 7,
  groups,
  isPending,
  titleGap = gap,
  titleTypography = DEFAULT_HEADING_LEVEL_3_TYPOGRAPHY,
  ...props
}: ReadonlyListStackProps) {
  return (
    <VerticalStack gap={gap} {...props}>
      {groups.map((group) => (
        <ReadonlyList
          defaultLinkElement={defaultLinkElement}
          id={group.id}
          isPending={isPending}
          items={group.items}
          key={group.id}
          title={group.title}
          titleGap={group.titleGap || titleGap}
          titleTypography={group.titleTypography || titleTypography}
        />
      ))}
    </VerticalStack>
  );
}
